import data from './data.json';

type Translation = {
	[key: string]: {
		[key: string]: string;
	};
};

export const translations = (language: string) => {
	return (
		key: string,
		parameters: { [key: string]: string } = {},
		pluralize: number = 0
	): string => {
		let translation = (data as Translation)?.[key]?.[language];

		if (translation === undefined) {
			return `[${key}]`;
		}

		if (pluralize > 0) {
			const parts = translation.split('|');
			translation = parts[pluralize > 1 ? 1 : 0];
		}

		if (Object.keys(parameters).length !== 0) {
			for (const parameter of Object.entries(parameters)) {
				translation = translation.replaceAll(`{${parameter[0]}}`, parameter[1]);
			}
		}

		return translation;
	};
};
